import { Language } from '../types/language';

export const translations: Record<Language, Record<string, string>> = {
  en: {
    'nav.home': 'Home',
    'nav.features': 'Features',
    'nav.comparison': 'Comparison',
    'nav.asianMarket': 'Asian Market',
    'hero.launch': 'TON Blockchain\'s Next Evolution',
    'hero.title': 'The Future of Trading with TBCC',
    'hero.subtitle': 'A decentralized trading protocol on TON blockchain with the speed of centralized exchanges and the security of blockchain technology.',
    'hero.learnMore': 'Learn More',
    'hero.viewDocs': 'View Documentation',
    'hero.feature1': 'Lightning Fast',
    'hero.feature1.desc': 'Orders execute in ~3 seconds, comparable to centralized exchanges',
    'hero.feature2': 'Fully Anonymous',
    'hero.feature2.desc': 'No KYC required, trade with complete privacy',
    'hero.feature3': 'Chain Verified',
    'hero.feature3.desc': 'All transactions are transparent and verifiable on-chain',
    'launch.countdown': 'Time until launch',
    'launch.days': 'Days',
    'launch.hours': 'Hours',
    'launch.minutes': 'Minutes',
    'launch.seconds': 'Seconds',
    'features.title': 'Advanced Trading Features',
    'features.subtitle': 'Experience the next generation of decentralized trading',
    'features.sequencer': 'Advanced Sequencer',
    'features.sequencer.desc': 'Our proprietary sequencer ensures ultra-fast order execution and optimal pricing',
    'features.sequencer.bullet1': 'Instant price and time recording',
    'features.sequencer.bullet2': 'No dependency on on-chain confirmations',
    'features.sequencer.bullet3': 'Prioritizes stop-loss/take-profit orders',
    'features.sequencer.bullet4': 'Minimizes slippage risks',
    'features.batch': 'Smart Batch Processing',
    'features.batch.desc': 'Intelligent order batching for maximum efficiency and minimal gas costs',
    'features.batch.bullet1': 'Priority 1: Stop-loss/Take-profit orders',
    'features.batch.bullet2': 'Priority 2: Market orders',
    'features.batch.bullet3': 'Priority 3: Limit orders',
    'features.batch.bullet4': 'On-chain verification for all executions',
    'features.display': 'Real-time Display',
    'features.display.desc': 'Instant updates and seamless position tracking without blockchain delays',
    'features.display.bullet1': 'Immediate position updates',
    'features.display.bullet2': 'Eliminates standard TON blockchain delays',
    'features.display.bullet3': 'Real-time portfolio tracking',
    'features.display.bullet4': 'Seamless user experience',
    'features.privacy': 'Enhanced Privacy',
    'features.privacy.desc': 'Trade with confidence using our advanced privacy protection features',
    'features.privacy.bullet1': 'Zero KYC requirements',
    'features.privacy.bullet2': 'Simple TON wallet connection',
    'features.privacy.bullet3': 'One-click trading activation',
    'features.privacy.bullet4': 'Complete privacy protection',
    'comparison.title': 'Why Choose TBCC?',
    'comparison.subtitle': 'Compare TBCC with traditional DEXs and centralized exchanges',
    'comparison.feature': 'Feature',
    'comparison.traditional': 'Traditional DEX',
    'comparison.centralized': 'Centralized Exchange',
    'comparison.speed': 'Execution Speed',
    'comparison.speed.tbcc': 'Ultra Fast (~3s)',
    'comparison.speed.dex': 'Slow (30s+)',
    'comparison.speed.cex': 'Very Fast (~1s)',
    'comparison.anonymity': 'Anonymity',
    'comparison.anonymity.tbcc': 'Full Privacy',
    'comparison.anonymity.dex': 'Full Privacy',
    'comparison.anonymity.cex': 'KYC Required',
    'comparison.transparency': 'Transparency',
    'comparison.transparency.tbcc': 'Fully Transparent',
    'comparison.transparency.dex': 'Transparent',
    'comparison.transparency.cex': 'Limited',
    'comparison.ease': 'Ease of Use',
    'comparison.ease.tbcc': 'Very Easy',
    'comparison.ease.dex': 'Complex',
    'comparison.ease.cex': 'Moderate',
    'comparison.telegram': 'Telegram Integration',
    'comparison.telegram.tbcc': 'Native Support',
    'comparison.telegram.dex': 'No Support',
    'comparison.telegram.cex': 'Limited Support',
    'comparison.conclusion': 'TBCC combines the best of both worlds: the speed of centralized exchanges with the security and privacy of decentralized platforms.',
    'asian.title': 'Expanding Across Asian Markets',
    'asian.subtitle': 'Leading the way in Asian cryptocurrency trading with innovative features and local support',
    'asian.users': 'Active Users',
    'asian.transactions': 'Daily Transactions',
    'asian.countries': 'Asian Countries',
    'asian.whyTitle': 'Why Asia Chooses TBCC',
    'asian.expansion': 'Strategic Expansion',
    'asian.expansion.desc': 'Focused growth across major Asian markets with localized support and services',
    'asian.telegram': 'Telegram Integration',
    'asian.telegram.desc': 'Seamless trading through Asia\'s most popular messaging platform',
    'asian.privacy': 'Privacy First',
    'asian.privacy.desc': 'Enhanced privacy features designed for Asian regulatory requirements',
    'asian.adoption': 'Market Adoption',
    'asian.china': 'China & Hong Kong',
    'asian.southeast': 'Southeast Asia',
    'asian.korea': 'South Korea',
    'asian.rest': 'Other Regions',
    'asian.growth': 'Projected 300% growth in Asian markets by 2024',
    'asian.explore': 'Explore Asian Markets'
  },
  zh: {
    'nav.home': '首页',
    'nav.features': '功能',
    'nav.comparison': '对比',
    'nav.asianMarket': '亚洲市场',
    'hero.launch': 'TON区块链的新进化',
    'hero.title': 'TBCC：交易的未来',
    'hero.subtitle': '基于TON区块链的去中心化交易协议，具有中心化交易所的速度和区块链的安全性。',
    'hero.learnMore': '了解更多',
    'hero.viewDocs': '查看文档',
    'hero.feature1': '闪电般速度',
    'hero.feature1.desc': '订单在约3秒内执行，媲美中心化交易所',
    'hero.feature2': '完全匿名',
    'hero.feature2.desc': '无需KYC，保护交易隐私',
    'hero.feature3': '链上验证',
    'hero.feature3.desc': '所有交易透明且可在链上验证',
    'launch.countdown': '距离启动还有',
    'launch.days': '天',
    'launch.hours': '小时',
    'launch.minutes': '分钟',
    'launch.seconds': '秒',
    'features.title': '先进交易功能',
    'features.subtitle': '体验下一代去中心化交易',
    'features.sequencer': '高级排序器',
    'features.sequencer.desc': '我们的专有排序器确保超快的订单执行和最优定价',
    'features.sequencer.bullet1': '即时价格和时间记录',
    'features.sequencer.bullet2': '无需依赖链上确认',
    'features.sequencer.bullet3': '优先处理止损/止盈订单',
    'features.sequencer.bullet4': '最小化滑点风险',
    'features.batch': '智能批处理',
    'features.batch.desc': '智能订单批处理，实现最高效率和最低gas成本',
    'features.batch.bullet1': '优先级1：止损/止盈订单',
    'features.batch.bullet2': '优先级2：市价订单',
    'features.batch.bullet3': '优先级3：限价订单',
    'features.batch.bullet4': '所有执行的链上验证',
    'features.display': '实时显示',
    'features.display.desc': '无区块链延迟的即时更新和无缝持仓跟踪',
    'features.display.bullet1': '即时持仓更新',
    'features.display.bullet2': '消除标准TON区块链延迟',
    'features.display.bullet3': '实时投资组合跟踪',
    'features.display.bullet4': '无缝用户体验',
    'features.privacy': '增强隐私',
    'features.privacy.desc': '使用我们的高级隐私保护功能安心交易',
    'features.privacy.bullet1': '零KYC要求',
    'features.privacy.bullet2': '简单TON钱包连接',
    'features.privacy.bullet3': '一键交易激活',
    'features.privacy.bullet4': '完整隐私保护',
    'comparison.title': '为什么选择TBCC？',
    'comparison.subtitle': '将TBCC与传统DEX和中心化交易所进行比较',
    'comparison.feature': '功能',
    'comparison.traditional': '传统DEX',
    'comparison.centralized': '中心化交易所',
    'comparison.speed': '执行速度',
    'comparison.speed.tbcc': '超快（~3秒）',
    'comparison.speed.dex': '慢（30秒+）',
    'comparison.speed.cex': '很快（~1秒）',
    'comparison.anonymity': '匿名性',
    'comparison.anonymity.tbcc': '完全隐私',
    'comparison.anonymity.dex': '完全隐私',
    'comparison.anonymity.cex': '需要KYC',
    'comparison.transparency': '透明度',
    'comparison.transparency.tbcc': '完全透明',
    'comparison.transparency.dex': '透明',
    'comparison.transparency.cex': '有限',
    'comparison.ease': '易用性',
    'comparison.ease.tbcc': '非常简单',
    'comparison.ease.dex': '复杂',
    'comparison.ease.cex': '一般',
    'comparison.telegram': 'Telegram集成',
    'comparison.telegram.tbcc': '原生支持',
    'comparison.telegram.dex': '不支持',
    'comparison.telegram.cex': '有限支持',
    'comparison.conclusion': 'TBCC结合了两个世界的优点：中心化交易所的速度和去中心化平台的安全性与隐私性。',
    'asian.title': '扩展亚洲市场',
    'asian.subtitle': '通过创新功能和本地支持引领亚洲加密货币交易',
    'asian.users': '活跃用户',
    'asian.transactions': '日交易量',
    'asian.countries': '亚洲国家',
    'asian.whyTitle': '为什么亚洲选择TBCC',
    'asian.expansion': '战略扩张',
    'asian.expansion.desc': '专注于主要亚洲市场的增长，提供本地化支持和服务',
    'asian.telegram': 'Telegram集成',
    'asian.telegram.desc': '通过亚洲最受欢迎的消息平台进行无缝交易',
    'asian.privacy': '隐私优先',
    'asian.privacy.desc': '根据亚洲监管要求设计的增强隐私功能',
    'asian.adoption': '市场采用',
    'asian.china': '中国和香港',
    'asian.southeast': '东南亚',
    'asian.korea': '韩国',
    'asian.rest': '其他地区',
    'asian.growth': '预计2024年亚洲市场增长300%',
    'asian.explore': '探索亚洲市场'
  },
  ko: {
    'nav.home': '홈',
    'nav.features': '기능',
    'nav.comparison': '비교',
    'nav.asianMarket': '아시아 시장',
    'hero.launch': 'TON 블록체인의 새로운 진화',
    'hero.title': 'TBCC와 함께하는 거래의 미래',
    'hero.subtitle': 'TON 블록체인 기반의 탈중앙화 거래 프로토콜로, 중앙화 거래소의 속도와 블록체인의 보안성을 결합했습니다.',
    'hero.learnMore': '자세히 알아보기',
    'hero.viewDocs': '문서 보기',
    'hero.feature1': '번개같은 속도',
    'hero.feature1.desc': '주문 실행이 약 3초 내로 완료되어 중앙화 거래소와 비슷합니다',
    'hero.feature2': '완전한 익명성',
    'hero.feature2.desc': 'KYC 불필요, 완벽한 개인정보 보호',
    'hero.feature3': '체인 검증',
    'hero.feature3.desc': '모든 거래가 투명하며 체인상에서 검증 가능합니다',
    'launch.countdown': '출시까지 남은 시간',
    'launch.days': '일',
    'launch.hours': '시간',
    'launch.minutes': '분',
    'launch.seconds': '초',
    'features.title': '고급 거래 기능',
    'features.subtitle': '차세대 탈중앙화 거래를 경험하세요',
    'features.sequencer': '고급 시퀀서',
    'features.sequencer.desc': '당사의 독점 시퀀서로 초고속 주문 실행과 최적 가격을 보장합니다',
    'features.sequencer.bullet1': '즉각적인 가격 및 시간 기록',
    'features.sequencer.bullet2': '체인 확인 의존도 없음',
    'features.sequencer.bullet3': '손절/이익실현 주문 우선 처리',
    'features.sequencer.bullet4': '슬리피지 위험 최소화',
    'features.batch': '스마트 배치 처리',
    'features.batch.desc': '최대 효율성과 최소 가스비용을 위한 지능형 주문 배치',
    'features.batch.bullet1': '우선순위 1: 손절/이익실현 주문',
    'features.batch.bullet2': '우선순위 2: 시장가 주문',
    'features.batch.bullet3': '우선순위 3: 지정가 주문',
    'features.batch.bullet4': '모든 실행에 대한 체인상 검증',
    'features.display': '실시간 표시',
    'features.display.desc': '블록체인 지연 없는 즉각적인 업데이트와 원활한 포지션 추적',
    'features.display.bullet1': '즉각적인 포지션 업데이트',
    'features.display.bullet2': '표준 TON 블록체인 지연 제거',
    'features.display.bullet3': '실시간 포트폴리오 추적',
    'features.display.bullet4': '원활한 사용자 경험',
    'features.privacy': '강화된 개인정보 보호',
    'features.privacy.desc': '고급 개인정보 보호 기능으로 자신있게 거래하세요',
    'features.privacy.bullet1': 'KYC 요구사항 없음',
    'features.privacy.bullet2': '간단한 TON 지갑 연결',
    'features.privacy.bullet3': '원클릭 거래 활성화',
    'features.privacy.bullet4': '완벽한 개인정보 보호',
    'comparison.title': 'TBCC를 선택하는 이유',
    'comparison.subtitle': 'TBCC와 전통적인 DEX 및 중앙화 거래소 비교',
    'comparison.feature': '기능',
    'comparison.traditional': '전통적인 DEX',
    'comparison.centralized': '중앙화 거래소',
    'comparison.speed': '실행 속도',
    'comparison.speed.tbcc': '초고속 (~3초)',
    'comparison.speed.dex': '느림 (30초+)',
    'comparison.speed.cex': '매우 빠름 (~1초)',
    'comparison.anonymity': '익명성',
    'comparison.anonymity.tbcc': '완전한 개인정보',
    'comparison.anonymity.dex': '완전한 개인정보',
    'comparison.anonymity.cex': 'KYC 필요',
    'comparison.transparency': '투명성',
    'comparison.transparency.tbcc': '완전 투명',
    'comparison.transparency.dex': '투명',
    'comparison.transparency.cex': '제한적',
    'comparison.ease': '사용 용이성',
    'comparison.ease.tbcc': '매우 쉬움',
    'comparison.ease.dex': '복잡함',
    'comparison.ease.cex': '보통',
    'comparison.telegram': '텔레그램 통합',
    'comparison.telegram.tbcc': '기본 지원',
    'comparison.telegram.dex': '지원 안함',
    'comparison.telegram.cex': '제한적 지원',
    'comparison.conclusion': 'TBCC는 중앙화 거래소의 속도와 탈중앙화 플랫폼의 보안 및 개인정보 보호를 모두 갖추고 있습니다.',
    'asian.title': '아시아 시장 확장',
    'asian.subtitle': '혁신적인 기능과 현지 지원으로 아시아 암호화폐 거래를 선도합니다',
    'asian.users': '활성 사용자',
    'asian.transactions': '일일 거래량',
    'asian.countries': '아시아 국가',
    'asian.whyTitle': '아시아가 TBCC를 선택하는 이유',
    'asian.expansion': '전략적 확장',
    'asian.expansion.desc': '주요 아시아 시장에서의 성장에 집중하며 현지화된 지원과 서비스 제공',
    'asian.telegram': '텔레그램 통합',
    'asian.telegram.desc': '아시아에서 가장 인기 있는 메시징 플랫폼을 통한 원활한 거래',
    'asian.privacy': '개인정보 보호 우선',
    'asian.privacy.desc': '아시아 규제 요구사항에 맞춘 강화된 개인정보 보호 기능',
    'asian.adoption': '시장 채택',
    'asian.china': '중국 및 홍콩',
    'asian.southeast': '동남아시아',
    'asian.korea': '한국',
    'asian.rest': '기타 지역',
    'asian.growth': '2024년까지 아시아 시장 300% 성장 전망',
    'asian.explore': '아시아 시장 탐색'
  },
  ru: {
    'nav.home': 'Главная',
    'nav.features': 'Функции',
    'nav.comparison': 'Сравнение',
    'nav.asianMarket': 'Азиатский рынок',
    'hero.launch': 'Новая эволюция блокчейна TON',
    'hero.title': 'Будущее трейдинга с TBCC',
    'hero.subtitle': 'Децентрализованный торговый протокол на блокчейне TON со скоростью централизованных бирж и безопасностью блокчейна.',
    'hero.learnMore': 'Узнать больше',
    'hero.viewDocs': 'Документация',
    'hero.feature1': 'Молниеносная скорость',
    'hero.feature1.desc': 'Исполнение ордеров за ~3 секунды, как на централизованных биржах',
    'hero.feature2': 'Полная анонимность',
    'hero.feature2.desc': 'Без KYC, торгуйте с полной конфиденциальностью',
    'hero.feature3': 'Проверка в блокчейне',
    'hero.feature3.desc': 'Все транзакции прозрачны и проверяемы в блокчейне',
    'launch.countdown': 'Время до запуска',
    'launch.days': 'дней',
    'launch.hours': 'часов',
    'launch.minutes': 'минут',
    'launch.seconds': 'секунд',
    'features.title': 'Продвинутые торговые функции',
    'features.subtitle': 'Испытайте следующее поколение децентрализованной торговли',
    'features.sequencer': 'Продвинутый секвенсор',
    'features.sequencer.desc': 'Наш проприетарный секвенсор обеспечивает сверхбыстрое исполнение ордеров и оптимальное ценообразование',
    'features.sequencer.bullet1': 'Мгновенная запись цены и времени',
    'features.sequencer.bullet2': 'Нет зависимости от подтверждений в блокчейне',
    'features.sequencer.bullet3': 'Приоритет стоп-лосс/тейк-профит ордеров',
    'features.sequencer.bullet4': 'Минимизация рисков проскальзывания',
    'features.batch': 'Умная пакетная обработка',
    'features.batch.desc': 'Интеллектуальная пакетная обработка ордеров для максимальной эффективности и минимальных затрат на газ',
    'features.batch.bullet1': 'Приоритет 1: Стоп-лосс/тейк-профит ордера',
    'features.batch.bullet2': 'Приоритет 2: Рыночные ордера',
    'features.batch.bullet3': 'Приоритет 3: Лимитные ордера',
    'features.batch.bullet4': 'Проверка всех исполнений в блокчейне',
    'features.display': 'Отображение в реальном времени',
    'features.display.desc': 'Мгновенные обновления и отслеживание позиций без задержек блокчейна',
    'features.display.bullet1': 'Мгновенное обновление позиций',
    'features.display.bullet2': 'Устранение стандартных задержек блокчейна TON',
    'features.display.bullet3': 'Отслеживание портфеля в реальном времени',
    'features.display.bullet4': 'Безупречный пользовательский опыт',
    'features.privacy': 'Улучшенная конфиденциальность',
    'features.privacy.desc': 'Торгуйте уверенно с нашими продвинутыми функциями защиты конфиденциальности',
    'features.privacy.bullet1': 'Нулевые требования KYC',
    'features.privacy.bullet2': 'Простое подключение кошелька TON',
    'features.privacy.bullet3': 'Активация торговли в один клик',
    'features.privacy.bullet4': 'Полная защита конфиденциальности',
    'comparison.title': 'Почему TBCC?',
    'comparison.subtitle': 'Сравните TBCC с традиционными DEX и централизованными биржами',
    'comparison.feature': 'Функция',
    'comparison.traditional': 'Традиционный DEX',
    'comparison.centralized': 'Централизованная биржа',
    'comparison.speed': 'Скорость исполнения',
    'comparison.speed.tbcc': 'Сверхбыстро (~3с)',
    'comparison.speed.dex': 'Медленно (30с+)',
    'comparison.speed.cex': 'Очень быстро (~1с)',
    'comparison.anonymity': 'Анонимность',
    'comparison.anonymity.tbcc': 'Полная приватность',
    'comparison.anonymity.dex': 'Полная приватность',
    'comparison.anonymity.cex': 'Требуется KYC',
    'comparison.transparency': 'Прозрачность',
    'comparison.transparency.tbcc': 'Полностью прозрачно',
    'comparison.transparency.dex': 'Прозрачно',
    'comparison.transparency.cex': 'Ограничено',
    'comparison.ease': 'Простота использования',
    'comparison.ease.tbcc': 'Очень просто',
    'comparison.ease.dex': 'Сложно',
    'comparison.ease.cex': 'Умеренно',
    'comparison.telegram': 'Интеграция с Telegram',
    'comparison.telegram.tbcc': 'Нативная поддержка',
    'comparison.telegram.dex': 'Нет поддержки',
    'comparison.telegram.cex': 'Ограниченная поддержка',
    'comparison.conclusion': 'TBCC сочетает в себе лучшее из двух миров: скорость централизованных бирж с безопасностью и конфиденциальностью децентрализованных платформ.',
    'asian.title': 'Расширение на азиатских рынках',
    'asian.subtitle': 'Лидерство в азиатской криптовалютной торговле с инновационными функциями и локальной поддержкой',
    'asian.users': 'Активные пользователи',
    'asian.transactions': 'Ежедневные транзакции',
    'asian.countries': 'Азиатские страны',
    'asian.whyTitle': 'Почему Азия выбирает TBCC',
    'asian.expansion': 'Стратегическое расширение',
    'asian.expansion.desc': 'Целенаправленный рост на основных азиатских рынках с локализованной поддержкой и сервисами',
    'asian.telegram': 'Интеграция с Telegram',
    'asian.telegram.desc': 'Безупречная торговля через самую популярную в Азии платформу обмена сообщениями',
    'asian.privacy': 'Приватность прежде всего',
    'asian.privacy.desc': 'Улучшенные функции конфиденциальности, разработанные с учетом азиатских нормативных требований',
    'asian.adoption': 'Принятие рынком',
    'asian.china': 'Китай и Гонконг',
    'asian.southeast': 'Юго-Восточная Азия',
    'asian.korea': 'Южная Корея',
    'asian.rest': 'Другие регионы',
    'asian.growth': 'Прогнозируемый рост на азиатских рынках на 300% к 2024 году',
    'asian.explore': 'Исследовать азиатские рынки'
  }
};